/* eslint-disable no-undef */
/* eslint-disable vars-on-top */
import { Auth } from 'aws-amplify'
import { submitToApi as submitToApiLib } from '@wellbeingxltd/fe-lib/api/src'
import store from 'store'
import { logout } from 'helpers/smallUtils'

// Redirect old subdomains to app.betterspace.uk
const OLD_SUBDOMAINS = [
    'accenture',
    'blink',
    'cafe-direct',
    'cowry',
    'cyance',
    'escapethecity',
    'greenhousesports',
    'mees',
    'revantage',
    'team',
    'wikimedia',
    'xwhy',
]

const splitUrl = window.location.hostname.split('.')

if (splitUrl.length >= 3) {
    const subdomain = splitUrl[0]

    if (OLD_SUBDOMAINS.some(oldSubdomain => subdomain.includes(oldSubdomain))) {
        window.location.replace(`https://app.betterspace.uk${window.location.pathname}${window.location.search}${window.location.hash}`)
    }
}

// Setup environment
let __ENV__

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || window.location.origin.match(/https?:\/\/dev-/)) __ENV__ = 'DEV'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/demo-/)) __ENV__ = 'DEMO'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/stg-/)) __ENV__ = 'STG'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/(prd-|app.)/)) __ENV__ = 'PRD'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/d2pehboqvv5n2m./)) __ENV__ = 'PRD'

// __ENV__ = 'DEV'
// __ENV__ = 'DEMO'
// __ENV__ = 'STG'
// __ENV__ = 'PRD'

export { __ENV__ }

console.log(`%c env: ${__ENV__}`, 'color: #6f6')

// TODO move to AWS Secrets Manager
export const STRIPE_KEY = __ENV__ === 'PRD' ? 'pk_live_x5EX7jJT6arZMATdT0tC2tRN00IY2eFHjE' : 'pk_test_9eiy4PeHmK1QYq9u1CiLwdyc00UR9W8Z5G'

// For full list of props, see https://github.com/wellbeingxltd/fe-lib/blob/main/api/src/index.js
export function submitToApi(props) {
    return Auth.currentCredentials().then(creds => {
        return Auth.currentAuthenticatedUser()
            .then(cognitoUser => {
                return Promise.resolve(submitToApiLib({ cognitoUser, creds, userProfile: store.getState().profile.database.userProfile, ...props }))
            })
            .catch(error => {
                return Promise.reject(error)
            })
    })
}

export function amplifyAuthentication(credentials, successCallback = () => {}, errorCallback = () => {}) {
    console.log('[amplifyAuthentication]', credentials)

    Auth.signIn({
        username: credentials.username,
        password: credentials.password,
    })
        .then(signInRes => {
            // e.g. Betterspace, Affinity
            console.log('[amplifyAuthentication] signInRes', signInRes)
            console.log('******* signInRes: ****** ', signInRes)
            localStorage.setItem('cognitoUser', JSON.stringify(signInRes))
            successCallback(signInRes)
            if (signInRes.challengeName === 'SMS_MFA') return
        })
        .catch(signInError => {
            console.log('[amplifyAuthentication] Error', signInError)
            errorCallback(signInError)
        })
}

export function amplifyAuthenticationConfirmation(code, successCallback = () => {}, errorCallback = () => {}) {
    Auth.confirmSignIn(cognitoUser, code, 'SMS_MFA')
        .then(confirmSignInRes => {
            successCallback(confirmSignInRes)
            localStorage.setItem('cognitoUser', JSON.stringify(confirmSignInRes))

            const accToken = confirmSignInRes.signInUserSession.accessToken.jwtToken
            const idToken = confirmSignInRes.signInUserSession.idToken.jwtToken
            authentication(accToken, idToken, () => {}, errorCallback)
        })
        .catch(confirmSignInError => {
            errorCallback(`${confirmSignInError.code}: ${confirmSignInError.message}`)
        })
}

export const amplifySignup = async (params, MFAtype, successCallback = () => {}, errorCallback = () => {}) => {
    console.log('[amplifySignup]', { params, MFAtype })

    try {
        const response = await Auth.signUp(params)
        console.log('[signUp]', response)
        successCallback(response)
    } catch (error) {
        console.log('[signup error] ', error)

        let errorMessage = ''

        if (error.code === 'UsernameExistsException') {
            errorMessage = 'An account with the given email already exists. Please try a different email or go back to the previous screen and Login.'
        } else if (
            error.message.toLowerCase().includes('not authorized') ||
            error.message.toLowerCase().includes('not recognised') ||
            error.message.toLowerCase().includes("cannot read property 'pilottag'")
        ) {
            errorMessage = 'This email has not been approved to use Betterspace. If you should have access, please contact support@betterspace.uk'
        } else if (error.message.toLowerCase().includes('email address format')) {
            errorMessage =
                'The email you have entered is not a valid email format. Please try again or contact support@betterspace.uk for assistance.'
        } else if (error.message.toLowerCase().includes('password')) {
            errorMessage = `The password you have entered is not valid. Your Betterspace password does not have to be the same as your company password. It must have a minimum of 8 characters: 1 lowercase letter, 1 uppercase letter, 1 number and 1 symbol (=+-^$*.[]{}()?"!@#%&/\\,><':;|_~\`). Please try again or contact support@betterspace.uk for assistance.`
        } else if (error.message.toLowerCase().includes('invitation code')) {
            errorMessage = 'The invitation code in incorrect. Please check for typos or contact support@betterspace.uk for assistance.'
        } else if (error.message.toLowerCase().includes('can not use your work email')) {
            errorMessage = 'Your employer has requested that you do not use your work email to signup for Betterspace.'
        } else if (error.message.toLowerCase().includes('should use your work email')) {
            errorMessage = 'Please use the same email in which you received your invitation link.'
        } else {
            errorMessage = `Something went wrong, please contact support@betterspace.uk and quote the following error message: ${error.code} - ${error.message}`
        }
        errorCallback(errorMessage)
    }
}

export function confirmSignUp(code, email, successCallback = () => {}, errorCallback = () => {}) {
    Auth.confirmSignUp(email, code)
        .then(res => {
            console.log('[AWSAPI - confirmSignUp]', res)

            successCallback(res)
        })
        .catch(err => {
            console.log('[AWSAPI - confirmSignUp]ERROR', err)
            errorCallback(err)
        })
}

export function amplifyVerifyMobileNumber(successCallback = () => {}, errorCallback = () => {}) {
    Auth.verifyCurrentUserAttribute('phone_number')
        .then(() => {
            successCallback()
        })
        .catch(err => {
            errorCallback(`Something went wrong with verifying your mobile number, please try again. ${err.code}: ${err.message}`)
        })
}

export function amplifyVerifyMobileNumberSubmit(code, successCallback = () => {}, errorCallback = () => {}) {
    Auth.verifyCurrentUserAttributeSubmit('phone_number', code)
        .then(() => {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    successCallback(user)
                })
                .catch(err => {
                    errorCallback(err)
                })
        })
        .catch(verifyCurrentUserAttributeSubmitError => {
            errorCallback(`${verifyCurrentUserAttributeSubmitError.code}: ${verifyCurrentUserAttributeSubmitError.message}`)
        })
}

export function amplifyChangeMobileNumber(phone, successCallback = () => {}, errorCallback = () => {}) {
    Auth.currentAuthenticatedUser()
        .then(user => {
            Auth.updateUserAttributes(user, { phone_number: phone })
                .then(() => {
                    Auth.currentAuthenticatedUser({ bypassCache: true })
                    successCallback()
                })
                .catch(err => {
                    switch (err.code) {
                        default:
                            errorCallback(`${err.code}: ${err.message}`)
                    }
                })
        })
        .catch(err => {
            errorCallback(`${err.code}: ${err.message}`)
        })
}

export function forgotPassword(email, successCallback = () => {}, errorCallback = () => {}) {
    Auth.forgotPassword(email)
        .then(data => {
            console.log('[API] forgotPassword success ')
            successCallback()
        })
        .catch(err => {
            console.log('[API] forgotPassword error ', err)
            errorCallback(err)
        })
}

export function forgotPasswordSubmit(email, code, password, successCallback, errorCallback) {
    Auth.forgotPasswordSubmit(email, code, password)
        .then(data => {
            successCallback()
        })
        .catch(err => {
            errorCallback(err)
        })
}

export const isAuthenticated = async () => {
    try {
        //check expiration Time
        const expires_at = localStorage.getItem('willExpire')
        const parsedExpires_at = JSON.parse(expires_at)
        if (expires_at && new Date().getTime() > parsedExpires_at) {
            logout()
            return Promise.resolve(false)
        }
        //then check the expiration of the session
        await Auth.currentAuthenticatedUser()
        return Promise.resolve(true)
    } catch (error) {
        return Promise.reject(false)
    }
}
